import React from "react";
import { Row } from "antd";
import { CustomerFinanceCard } from "../contents/customer-finance-card";
import { CustomerActivityCard } from "../contents/customer-activity-card";
import { CustomerCalendarCard } from "../contents/customer-calendar-card";
import { CustomerDocumentsCard } from "../contents/customer-documents-card";
import receiptOutline from "../../assets/images/receipt-outline.svg";
import cashOutline from "../../assets/images/cash-outline.svg";
import calendarClearOutline from "../../assets/images/calendar-clear-outline.svg";
import linkOutline from "../../assets/images/link-outline.svg";


export const Customer: React.FC = () => {
  return (
    <>
      <Row gutter={[12, 12]}>
        <CustomerFinanceCard
          title={"Facility limit"}
          tooltip={""}
          icon={cashOutline}
          details={{"currentAmountDue":"€82,000.00", "nextPaymentDate":"29 December 2025","nextPaymentAmount":"€5,400.00", "monthlyServiceFee":"0.6%"  }}
        ></CustomerFinanceCard>

        <CustomerActivityCard
          title={"Facility limit"}
          tooltip={""}
          icon={receiptOutline}
          details={"€82,000.00"}
        ></CustomerActivityCard>

        <CustomerCalendarCard
          title={"Term end date"}
          tooltip={""}
          icon={calendarClearOutline}
          details={{"termEndDate":"29 May 2025", "finalRepaymentDate":"29 June 2025"}}
        ></CustomerCalendarCard>

        <CustomerDocumentsCard
          title={"Documents & Connections"}
          icon={linkOutline}
          details={"Documents & Connections"}
        ></CustomerDocumentsCard>
      </Row>
    </>
  );
};
